/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FoodDrinkAlcoGlassWineIcon20Regular = forwardRef('FoodDrinkAlcoGlassWineIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 3.889C3 2.846 3.846 2 4.889 2H15.11C16.154 2 17 2.846 17 3.889V6.75a7.001 7.001 0 0 1-6.25 6.96v3.54h3.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5h3.5v-3.54A7.001 7.001 0 0 1 3 6.75V3.889ZM15.45 7.5a5.501 5.501 0 0 1-10.9 0h10.9ZM15.5 6h-11V3.889c0-.215.174-.389.389-.389H15.11c.215 0 .389.174.389.389V6Z" })));
});
